<div class="p-7 w-full bg-white">
	<form [formGroup]="searchForm" (ngSubmit)="onSearch()">
		<div class="flex flex-col md:flex-row items-center border border-gray-300 rounded-lg overflow-hidden">
			<div class="relative w-full md:w-2/5">
				<input type="search" placeholder="Rechercher un lieu" formControlName="town"
					class="w-full !rounded-none !border-none h-12 bg-slate-100 placeholder:text-sm text-sm px-5 pr-8" />
				<!-- Loader dans le champ ville (DPP) -->
				<div *ngIf="townLoading"
					class="pointer-events-none absolute inset-y-0 right-3 flex items-center justify-center">
					<span
						class="inline-block w-3 h-3 border-2 border-gray-300 border-t-primary rounded-full animate-spin"></span>
				</div>
				<!-- Bouton clear ville (visible quand il y a une valeur et pas de chargement) -->
				<div class=" absolute inset-y-0 right-3 flex items-center justify-center">
					<button *ngIf="hasTownValue && !townLoading" type="button" (click)="clearTown()"
						class=" flex items-center justify-center w-6 h-6 rounded-full hover:bg-gray-200 text-gray-500 hover:text-gray-700 focus:outline-none"
						aria-label="Effacer le lieu">
						<span class="text-lg leading-none">×</span>
					</button>
				</div>
			</div>
			<div class="h-7 w-px bg-gray-300 block">
			</div>
			<div class="relative w-full md:w-2/5">
				<input type="search" placeholder="Médecin, Structure, Pharmacie..." formControlName="query"
					class="w-full !rounded-none h-12 !border-none bg-slate-100 placeholder:text-sm text-sm px-5 pr-8" />
				<!-- Loader dans le champ de recherche prestataire (DPP) -->
				<div *ngIf="queryLoading"
					class="pointer-events-none absolute inset-y-0 right-3 flex items-center justify-center">
					<span
						class="inline-block w-3 h-3 border-2 border-gray-300 border-t-primary rounded-full animate-spin"></span>
				</div>
				<!-- Bouton clear prestataire (DPP) -->
				<div class="absolute inset-y-0 right-3 flex items-center justify-center">
					<button *ngIf="hasQueryValue && !queryLoading" type="button" (click)="clearQuery()"
						class=" flex items-center justify-center w-6 h-6 rounded-full hover:bg-gray-200 text-gray-500 hover:text-gray-700 focus:outline-none"
						aria-label="Effacer la recherche">
						<span class="text-lg leading-none">×</span>
					</button>
				</div>
			</div>
			<button type="submit"
				class="btn-primary !h-12 !flex-grow !rounded-none !font-normal w-full md:w-fit">Rechercher</button>
		</div>
	</form>

	<div class="mt-7 grid gap-5" [ngClass]="getGridClasses()">
		<select *ngIf="showLanguageField" class="h-10 text-sm text-gray-600 select bg-white w-full"
			(change)="onLanguageChange($event)">
			<option value="">Sélectionner une langue</option>
			<option *ngFor="let language of languages$ | async" [value]="language.id">{{ language.label }}</option>
		</select>
		<select *ngIf="showServiceField" class="h-10 text-sm text-gray-600 select bg-white w-full"
			(change)="onServiceChange($event)">
			<option value="">Sélectionner un service</option>
			<option *ngFor="let service of services$ | async" [value]="service.id">{{ service.name }}</option>
		</select>
		<select class="h-10 text-sm text-gray-600 select bg-white w-full" (change)="onInsurerChange($event)">
			<option value="">Sélectionner un assureur</option>
			<option *ngFor="let insurer of insurers$ | async" [value]="insurer.id">{{ insurer.name }}</option>
		</select>
	</div>

	<!-- Affichage des erreurs -->
	<div *ngIf="error$ | async as error" class="mt-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded">
		{{ error }}
	</div>

	<!-- Indicateur de chargement -->
	<div *ngIf="loading$ | async" class="mt-4 text-center text-gray-600">
		Chargement des données...
	</div>
</div>